import { APIClient } from "../helpers/api_helper";

// Admin-only endpoints. Every call is gated server-side by requireAdmin, which
// reads users.is_admin from the row rather than trusting the token.
const api = new APIClient();

// Members with sign-in, subscription and research activity, plus a summary.
export const getAdminUsers = () => api.get("/api/admin/users");
